import { IMAGES } from "@/lib/images";
import { Target, ShieldCheck, Bot, Award } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-16" data-testid="about-page">
      <p className="text-xs font-mono uppercase tracking-[0.2em] text-gold mb-2">About Certalyth Academy</p>
      <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-white">Learn. Prove. Certify. Advance.</h1>
      <img src={IMAGES.examScene} alt="Certalyth Academy" className="w-full h-64 object-cover rounded-2xl mt-8 border border-white/10" />
      <p className="text-lg text-slate-300 mt-8 leading-relaxed">
        Certalyth Academy is an independent platform for online IT courses, exams, and certifications.
        We offer complete study materials aligned with industry-recognized certifications (Python, AWS, Azure, Google Cloud),
        timed online examinations, and certificates with a unique number that can be verified publicly.
      </p>
      <div className="grid sm:grid-cols-2 gap-5 mt-12">
        {[
          { icon: Target, t: "Certification-aligned", d: "Every course follows the structure of the official industry exams." },
          { icon: Bot, t: "Dedicated AI assistant", d: "An assistant that knows the course content and platform policies." },
          { icon: ShieldCheck, t: "Verifiable certificates", d: "Any certificate can be validated publicly via its unique code." },
          { icon: Award, t: "Fair examination", d: "Timed multiple-choice test, auto-graded, with a clear pass mark." },
        ].map((x, i) => (
          <div key={i} className="bg-surface-card rounded-xl p-6 border border-white/10" style={{ backgroundColor: "#131C38" }}>
            <div className="h-11 w-11 rounded-lg bg-gold/15 border border-gold/30 flex items-center justify-center mb-4"><x.icon className="h-5 w-5 text-gold" /></div>
            <h3 className="font-display font-semibold text-white">{x.t}</h3>
            <p className="text-sm text-slate-400 mt-2">{x.d}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 bg-surface rounded-xl p-6 border border-white/10 text-sm text-slate-400">
        <span className="text-white font-semibold">Independence: </span>
        Certalyth Academy is an independent entity. Exam names and trademarks belong to their respective owners.
        Our certificates attest to the completion of a Certalyth training programme and do not replace the vendor's official certification.
      </div>
    </div>
  );
}
